import StatisticBox from './StatisticBox';

export default StatisticBox;
